import { diffLines } from 'diff'
import type { FileUpdate } from '@/infra/sse/conversation/payloads'

export interface DiffStats {
  readonly linesAdded: number
  readonly linesRemoved: number
  readonly hunksCount: number
}

export function calculateDiffStats(updates: readonly FileUpdate[]): DiffStats {
  let linesAdded = 0
  let linesRemoved = 0

  for (const hunk of updates) {
    for (const line of hunk.lines) {
      if (line.startsWith('+')) linesAdded++
      if (line.startsWith('-')) linesRemoved++
    }
  }

  return {
    linesAdded,
    linesRemoved,
    hunksCount: updates.length,
  }
}

export function calculateDiffStatsFromStrings(oldString: string, newString: string): DiffStats {
  const changes = diffLines(oldString, newString)
  const linesAdded = changes.filter((c) => c.added).reduce((sum, c) => sum + (c.count || 0), 0)
  const linesRemoved = changes.filter((c) => c.removed).reduce((sum, c) => sum + (c.count || 0), 0)

  return {
    linesAdded,
    linesRemoved,
    hunksCount: 1,
  }
}

export function calculateWriteStats(content: string): DiffStats {
  return {
    linesAdded: content.split('\n').length,
    linesRemoved: 0,
    hunksCount: 1,
  }
}

export function formatDiffStats(stats: DiffStats): string {
  const parts: string[] = []
  if (stats.linesAdded > 0) parts.push(`+${stats.linesAdded}`)
  if (stats.linesRemoved > 0) parts.push(`-${stats.linesRemoved}`)
  return parts.join(' ')
}
